/** Responsive layout tokens — web sidebar dashboard vs native full-bleed. */
export const layout = {
  /** Narrow shell for onboarding / preview (px). */
  webAppMaxWidth: 680,
  /** Full dashboard shell: sidebar + content (px). */
  webDashboardMaxWidth: 1280,
  /** Fixed sidebar width on web desktop (px). */
  webSidebarWidth: 220,
  /** Side padding inside content column. */
  webGutter: 16,
  /** Content padding inside dashboard main area. */
  webContentPadding: 24,
  /** Viewport width at which framed shell appears. */
  webFrameBreakpoint: 768,
  /** Viewport width at which sidebar replaces bottom tab bar. */
  webSidebarBreakpoint: 768,
  /** Viewport width at which 2-column widget grid activates. */
  webTwoColumnBreakpoint: 1024,
  /** Max readable width for a single widget column. */
  webWidgetMaxWidth: 560,
  /** Native dashboard side gutter — matches the floating iOS tab bar inset. */
  nativeGutter: 20,
  /**
   * Extra scroll padding under the last widget.
   * Native UITabBar on iOS 26 floats over the scene; safe-area inset alone is not enough.
   */
  nativeTabBarClearance: 136,
} as const;

export type AppLayoutMode = 'native' | 'webCompact' | 'webSidebar' | 'webWide';
